"use client";
import { Provider } from "react-redux";
import { store } from "@/redux/store";
import { ReactNode, useEffect } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ThemeProvider } from "@/components/core/theme-provider/theme-provider";
import Cookies from "universal-cookie";
import { setToken } from "@/redux/authSlice";

interface LayoutProps {
  children: ReactNode;
}

const cookies = new Cookies();

export default function RootLayout({ children }: LayoutProps) {
  useEffect(() => {
    const token = cookies.get("token");
    if (token) {
      store.dispatch(setToken(token));
    } else {
      store.dispatch(setToken(undefined));
    }
  }, []);

  return (
    <html lang="en">
      <body>
        <Provider store={store}>
          <ThemeProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              {children}
            </LocalizationProvider>
          </ThemeProvider>
        </Provider>
      </body>
    </html>
  );
}
